function handleParams(params) {
  return params.map(function (param) {
    var type = typeof param;
    switch (type) {
      case "boolean":
        return {
          type: "BOOL",
          value: param,
        };
      case "number":
        return {
          type: "LONG",
          value: param,
        };
      case "object":
        return {
          type: "IDISPATCH",
          value: param.service.caller,
        };
      default:
        return {
          type: "BSTR",
          value: String(param),
        };
    }
  });
}

function parseParams(params) {
  const result = [];
  params.forEach((param) => {
    const { type, value } = param;

    switch (type) {
      case "BOOL":
        const val = value == "true" ? true : false;
        result.push(val);
        break;
      case "BSTR":
        result.push(value.toString());
        break;
      case "LONG":
        result.push(Number(value));
        break;
      default:
        result.push(value);
    }
  });

  return result;
}

function getContentBeforeParenthesis(input) {
  let parenthesisIndex = input.indexOf("(");
  return parenthesisIndex !== -1 ? input.substring(0, parenthesisIndex) : input;
}

function getScriptElementsWithEvents(id) {
  const selector = `script[language="JavaScript"][for="${id}"][event]`;
  const scripts = document.querySelectorAll(selector);
  const result = [];

  scripts.forEach((script) => {
    const event = script.getAttribute("event"); // 获取 event 属性
    const eventName = getContentBeforeParenthesis(event);
    const content = script.textContent.trim(); // 获取 script 的内容
    result.push({ event, content, eventName });
  });

  return result;
}

function isIE() {
  var userAgent = window.navigator.userAgent;
  var msie = userAgent.indexOf("MSIE ");
  var trident = userAgent.indexOf("Trident/");

  var isIE11 = !!document.documentMode; // For IE11, which does not have 'MSIE' in the userAgent string

  return msie > -1 || trident > -1 || isIE11;
}
function isEdge() {
  return /Edg/.test(navigator.userAgent);
}

function padStart(str, targetLength, padString = " ") {
  // 处理边界：若目标长度小于等于原字符串长度，直接返回原字符串
  if (targetLength <= str.length) return str;

  // 计算需要填充的次数（向上取整）
  const padCount = Math.ceil((targetLength - str.length) / padString.length);
  // 生成填充字符串（截断到需要的长度）
  const padding = padString.repeat(padCount).slice(0, targetLength - str.length);
  // 拼接原字符串和填充部分
  return padding + str;
}

// 初始化兼容的padStart函数
function getTime() {
  const now = new Date();

  // 获取时、分、秒
  let hours = now.getHours(); // 小时 (0-23)
  let minutes = now.getMinutes(); // 分钟 (0-59)
  let seconds = now.getSeconds(); // 秒 (0-59)

  // 格式化为两位数（补零）使用兼容的padStart
  hours = padStart(hours, 2, "0");
  minutes = padStart(minutes, 2, "0");
  seconds = padStart(seconds, 2, "0");

  // 拼接为 HH:mm:ss 格式
  return `${hours}:${minutes}:${seconds}`;
}

function generateWhiteImage(width, height) {
  // 创建一个 canvas 元素
  const canvas = document.createElement("canvas");
  canvas.width = width; // 设置宽度
  canvas.height = height; // 设置高度

  // 获取 2D 绘图上下文
  const ctx = canvas.getContext("2d");

  // 填充白色背景
  ctx.fillStyle = "#FFF"; // 白色
  ctx.fillRect(0, 0, width, height);

  // 新增内描边逻辑
  ctx.strokeStyle = "#CCCCCC"; // 使用浅灰色描边
  ctx.lineWidth = 1; // 1像素线宽
  ctx.strokeRect(1, 1, width - 1, height - 1); // 0.5偏移避免模糊

  // 将 canvas 转换为 Data URL
  return canvas.toDataURL("image/png"); // 返回 base64 编码的图片数据
}

function isFullScreen() {
  return window.outerWidth === window.screen.availWidth && window.outerHeight === window.screen.availHeight;
}

function hasVerticalScrollbar() {
  return document.documentElement.clientHeight > window.innerHeight;
}

function isInnerIframe() {
  return window.parent !== window.self;
}

function applyFirefoxPaddingFix(element) {
  // 检查是否为火狐浏览器，如果不是则直接返回
  const { browser } = getBrowser();
  if (browser !== "firefox") {
    return;
  }

  element.style.height = "100%";

  if (element.parentNode.style.height == "") {
    element.parentNode.style.height = "100%";
  }
}

async function createNewObject(root) {
  applyFirefoxPaddingFix(root.parentNode);

  const object = document.createElement("object");
  const validAttrNameRegex = /^[a-zA-Z]+$/; // 仅允许纯字母的属性名

  for (let attr of root.attributes) {
    if (validAttrNameRegex.test(attr.name)) {
      object.setAttribute(attr.name, attr.value);
    }
  }

  object.setAttribute("isFakeObject", true);

  const container = cretateNewContainer(object);

  // 用 object 替换 root 节点
  root.replaceWith(container);


  return object;
}

// 集中管理不同 type 对应的属性配置
const OBJECT_ATTRIBUTES = {
  iWebOffice: {
    clsid: "CLSID:D89F482C-5045-4DB5-8C53-D2C9EE71D025",
    progid: "Kinggrid.iWebOffice",
  },
  iWebPDF2018: {
    clsid: "CLSID:7017318C-BC50-4DAF-9E4A-10AC8364C315",
  },
};

const checkObjectElement = (id) => {
  try {
    const escapedId = CSS.escape(id); // 转义特殊字符
    const element = document.querySelector(`#${escapedId}`);
    if (!element) return false;
    if (element.tagName.toLowerCase() !== "object") return false;

    // 遍历 OBJECT_ATTRIBUTES 查找匹配的元素
    for (const [type, attributes] of Object.entries(OBJECT_ATTRIBUTES)) {
      if (
        element.getAttribute("clsid") === attributes.clsid ||
        (attributes.progid && element.getAttribute("progid") === attributes.progid)
      ) {
        return { element, type };
      }
    }
    return false;
  } catch (error) {
    return false;
  }
};

function cretateNewContainer(object) {
  const container = document.createElement("div");
  container.style.position = "relative";
  container.style.width = "100%";
  container.style.height = "100%";
  container.appendChild(object);

  return container;
}

function getParentScrollElementsOptimized(startElement) {
  const checkScroll = (el) => {
    const style = getComputedStyle(el);
    return el.scrollHeight > el.clientHeight && (style.overflowY === "auto" || style.overflowY === "scroll");
  };

  let currentWindow = window;
  let currentElement = startElement;

  while (true) {
    let current = currentElement;
    // 在当前页面查找滚动元素
    while (current) {
      if (checkScroll(current)) {
        return current;
      }
      current = current.parentElement;
    }

    // 当前页面没找到，向上查找父级 iframe
    if (currentWindow !== currentWindow.top) {
      try {
        const iframeElement = currentWindow.frameElement;
        currentWindow = currentWindow.parent;
        currentElement = iframeElement;
      } catch (error) {
        console.error("查找父级滚动元素失败:", error);
        return currentWindow;
      }
    } else {
      break;
    }
  }

  return currentWindow;
}

function is360Browser() {
  // 360浏览器特有插件标识
  const IDENTIFIERS = ["Suwell Reader Plugin", "np-mswmp", "mhjfbmdgcfjbbpaeojofohoefgiehjai"];

  return Array.from(navigator.plugins).some((plugin) => {
    // 安全检查：确保plugin对象有name和filename属性
    if (!plugin) return false;
    return IDENTIFIERS.includes(plugin.name) || IDENTIFIERS.includes(plugin.filename);
  });
}

/**
 * 获取浏览器信息
 */
function getBrowser() {
  const userAgent = navigator.userAgent.toLowerCase();
  const regexPatterns = [
    { regex: /(msie\s|trident.*rv:)([\w.]+)/, browser: "IE", versionIndex: 2 },
    { regex: /(firefox)\/([\w.]+)/, browser: 1, versionIndex: 2 },
    { regex: /(chrome)\/([\w.]+)/, browser: 1, versionIndex: 2 },
  ];

  // 优先检测360浏览器
  const is360 = is360Browser();

  if (is360) {
    const match = /(chrome)\/([\w.]+)/.exec(userAgent);
    const version = match ? parseInt(match[2].split(".")[0], 10) : 0;
    return { browser: "360", version };
  }

  // 检测其他浏览器
  for (const pattern of regexPatterns) {
    const match = pattern.regex.exec(userAgent);
    if (match) {
      const browserName = typeof pattern.browser === "number" ? match[pattern.browser] || "" : pattern.browser;
      const versionStr = match[pattern.versionIndex] || "0";
      const majorVersion = parseInt(versionStr.split(".")[0], 10);
      return { browser: browserName, version: majorVersion };
    }
  }

  // 默认返回未知浏览器
  return { browser: "", version: 0 };
}

/**
 * 整合360浏览器检测逻辑，返回详细类型信息
 * 使用localStorage和闭包双重缓存结果
 * @returns {Promise<string>} 浏览器类型标识符
 */
async function checkBrowser() {
  const BROWSER_CACHE_KEY = "kg_middleware_browser_type";

  // 1、内存缓存机制
  if (checkBrowser._cachedResult) {
    return checkBrowser._cachedResult;
  }

  // 2、 localStorage 缓存机制
  try {
    const cachedBrowser = localStorage.getItem(BROWSER_CACHE_KEY);
    if (cachedBrowser) {
      checkBrowser._cachedResult = cachedBrowser;
      return checkBrowser._cachedResult;
    }
  } catch (error) {
    console.error("localStorage 缓存读取失败:", error);
  }

  // 3. 执行实际的检测逻辑
  const result = await new Promise((resolve) => {
    // 增强型 Electron 检测（同时检查 userAgent 和 process 对象）
    const isElectron =
      navigator.userAgent.includes("Electron") || (typeof process !== "undefined" && process.versions?.electron);
    if (isElectron) {
      resolve("electron.exe");
      return;
    }

    let browser = "chrome.exe"; // 设置默认值
    const is360 = is360Browser();

    if (is360) {
      if (checkBrowser._isFetching) {
      } else {
        checkBrowser._isFetching = true;
        try {
          fetch("chrome-extension://fjbbmgamncjadhlpmffehlmmkdnkiadk/css/content.css")
            .then(() => {
              // 360 安全浏览器  360 AI浏览器
              const isSE = [...navigator.mimeTypes].some((m) => m.type === "application/gameplugin");

              if (isSE) {
                browser = "360se.exe";
                console.log("360 安全浏览器");
              } else {
                browser = "360aibrowser.exe";
                console.log("360 AI浏览器");
              }
            })
            .catch(() => {
              browser = "360Chrome.exe";
              console.log("360 极速浏览器");
            })
            .finally(() => {
              resolve(browser);
            });
        } catch (error) {
          browser = "360Chrome.exe";
          console.log("360 极速浏览器");
          resolve(browser);
        }
      }
    } else {
      const ua = navigator.userAgent.toLowerCase();

      if (ua.includes("edg/")) {
        browser = "msedge.exe";
        console.log("edge 浏览器");
      } else if (ua.includes("firefox/")) {
        browser = "firefox.exe";
        console.log("firefox 浏览器");
      } else if (ua.includes("chrome/")) {
        browser = "chrome.exe";
        console.log("chrome 浏览器");
      }

      resolve(browser);
    }
  });

  checkBrowser._cachedResult = result;
  try {
    localStorage.setItem(BROWSER_CACHE_KEY, result);
  } catch (error) {
    console.error("localStorage 缓存写入失败:", error);
  }

  return result;
}

function checkClientInstall() {
  const CACHE_KEY = "kg_middleware_client_check_result";

  // 检查sessionStorage中是否有缓存结果
  try {
    const cachedResult = sessionStorage.getItem(CACHE_KEY);
    if (cachedResult) {
      return JSON.parse(cachedResult);
    }
  } catch (storageError) {
    console.warn("从sessionStorage读取缓存失败:", storageError);
  }

  try {
    // 使用XMLHttpRequest进行同步请求
    const xhr = new XMLHttpRequest();
    xhr.open("GET", "https://local.kinggrid.com:9582/api/Midware/v1/kgmidware/check", false); // false表示同步请求

    // 设置请求头
    xhr.setRequestHeader("Content-Type", "application/json");

    try {
      xhr.send();

      // 检查响应状态
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          // 尝试解析JSON，确保data变量正确声明和初始化
          let data;
          try {
            data = JSON.parse(xhr.responseText);
            // 验证data是否为有效对象
            if (!data || typeof data !== "object") {
              throw new Error("无效的响应数据格式");
            }
          } catch (jsonError) {
            // 设置默认错误对象，避免返回无效值
            data = { err: "-1", usePpapi: 1 };
          }

          // 缓存结果
          const result = {
            // 0: 是否安装客户端
            installed: data.err === "0",
            // 1：使用PPAPI插件
            usePPAPI: data.usePpapi === 1,
          };

          // 保存到sessionStorage
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
          } catch (storageError) {
            console.warn("保存到sessionStorage失败:", storageError);
          }

          console.log("🚀  ~ checkClientInstall._cacheResult:", result);
          return result;
        } else {
          console.warn(`检查客户端安装状态失败: HTTP错误 ${xhr.status}`);
          // 缓存结果
          const result = { installed: false, usePPAPI: true };

          // 保存到sessionStorage
          try {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
          } catch (storageError) {
            console.warn("保存到sessionStorage失败:", storageError);
          }

          return result;
        }
      }
    } catch (networkError) {
      console.error("网络请求失败:", networkError);
    }
  } catch (error) {
    // 处理其他意外错误
    console.error("检查客户端安装状态时发生错误:", error);
  }

  // 缓存并返回默认值，避免返回无效值
  const result = {
    installed: false,
    usePPAPI: true,
  };

  // 保存到sessionStorage
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(result));
  } catch (storageError) {
    console.warn("保存到sessionStorage失败:", storageError);
  }

  console.log("🚀  ~ checkClientInstall._cacheResult:", result);
  return result;
}

import Mask from "./mask";
import ImageManager from "./ImageManager";
export {
  handleParams,
  parseParams,
  getScriptElementsWithEvents,
  isIE,
  isEdge,
  getBrowser,
  getTime,
  generateWhiteImage,
  isFullScreen,
  hasVerticalScrollbar,
  isInnerIframe,
  createNewObject,
  Mask,
  ImageManager,
  getParentScrollElementsOptimized,
  checkObjectElement,
  checkBrowser,
  checkClientInstall,
  is360Browser,
};
